import { ButtonHTMLAttributes, DetailedHTMLProps, FC } from 'react'
import { Memo } from '@/hoc/Memo'
import { cn } from '@bem-react/classname'

import './Toggler.scss'

const cnToggler = cn('Toggler')

export interface TogglerSchema
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  open: () => void
  blue?: boolean
  isOpen?: boolean
}

export const Toggler: FC<TogglerSchema> = Memo(
  ({ open, blue, isOpen, className }: TogglerSchema) => {
    return (
      <button
        className={cnToggler({ blue, open: isOpen }, [className])}
        onClick={open}
      >
        <span className={cnToggler('line')}></span>
        <span className={cnToggler('line')}></span>
        <span className={cnToggler('line')}></span>
      </button>
    )
  },
)
